import { render } from "./Sitemap.vue?vue&type=template&id=144f9d7a&scoped=true&ts=true"
import script from "./Sitemap.vue?vue&type=script&lang=ts"
export * from "./Sitemap.vue?vue&type=script&lang=ts"

import "./Sitemap.vue?vue&type=style&index=0&id=144f9d7a&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144f9d7a"]])

export default __exports__